export interface IZoomLevel {
  World: number;
  Continent: number;
  City: number;
  Streets: number;
  Buildings: number;
}

export interface IAnimation {
  BOUNCE: number;
  DROP: number;
}
